'use strict';

function LoanLiquidPayInFull() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();

    this.analytics.pushEvent('virtual-page-view');
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    if (!this._checkAdditionalPaymentFlowEligibility()) {
      return;
    }

    this._setupLivechat();

    $('.loans__tray-loader').addClass('hide');
    $('.loans__content-wrapper').removeClass('hide');
  };

  this._setupLivechat = function () {
    this._$chatBtn = $('.js--chat');
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$chatBtn.length && !this._liveChatComponent.length) {
      this._$chatBtn.mogo().create('LiveChat', { presenter: this.presenter });
    } else {
      this._liveChatComponent.mogo().hideChatIfNotEngaged();
    }

    this._$chatBtn.on('click', function (e) {
      e.preventDefault();
      if (window.LC_API && window.LC_API.open_chat_window) window.LC_API.open_chat_window();
    });
  };

  this.destroy = function () {
    this._super();
  };
}